import { css } from 'styled-components';

const Styles = css`
  .header-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .container {
    padding: 12px;
    width: 220px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 115px;
      padding: 8px;
    }
  }
  .right-border {
    border-right: 1px solid #d8d8d8;
  }
  .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: uppercase;
  }
  .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: uppercase;
  }
  .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: uppercase;
  }
  .email-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 16px;
    background-color: ${(props) => props.theme.colorPalette.blue[50]};
    border-radius: 6px;
    width: 35%;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
    margin-top: 28px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 87%;
      padding: 12px 16px;
      font-size: 12px;
    }
  }
  .email-link {
    text-decoration: underline;
    color: ${(props) => props.theme.colorPalette.blue[1300]};
    cursor: pointer;
  }
`;

export default Styles;
